export enum CalendarItemUserColumns {
    calendar_item_id = 'calendar_item_id',
    user_id = 'user_id',
    main = 'main',
}

export interface CalendarItemUserAttributes {
    calendar_item_id: number;
    user_id: number;
    main: boolean;
}

export type CalendarItemUserOptionalAttributes = 'main';
export interface CalendarItemUserCreate {
    calendar_item_id: number;
    user_id: number;
    main?: boolean;
}
